/**
 *
 * FullScreenSchedulerButton
 *
 */
import { FullScreenButton } from 'app/components/FullScreenButton';

export interface FullScreenSchedulerButtonProps {}

export function FullScreenSchedulerButton(
  props: FullScreenSchedulerButtonProps,
) {
  return <FullScreenButton selector="#main_div_content" />;
}
